var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.612,
    height: 150,
    viewBox: "0 0 147.612 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    d: "M59.9-1A60.9,60.9,0,1,1-1,59.9,60.972,60.972,0,0,1,59.9-1Zm0,107.475A46.573,46.573,0,1,0,13.33,59.9,46.625,46.625,0,0,0,59.9,106.475Z",
    fill: "#fffbf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_58",
    "data-name": "Line 58",
    d: "M43.423,50.588a7.143,7.143,0,0,1-5.066-2.1L1.1,11.231A7.165,7.165,0,0,1,11.231,1.1L48.49,38.357a7.165,7.165,0,0,1-5.066,12.231Z",
    transform: "translate(96.024 98.412)",
    fill: "#fffbf5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.554bb8f95a01025a8f632fd337bc3445.svg";
export { ForwardRef as ReactComponent };